import React from 'react'
import { connect } from 'react-redux'
import filter from 'lodash/filter'
import find from 'lodash/find'
import sortBy from 'lodash/sortBy'
import Icon from '../../misc/Icons'
import { formatDate } from '../../../utils/formatDate'
import SearchPreviewChildList from './SearchPreviewChildList'

// Resolve a list of folder ids to {name} entries; skip ids we can't find.
function resolveAncestors(ancestorIds, allFolders) {
  if (!Array.isArray(ancestorIds) || ancestorIds.length === 0) return []
  return ancestorIds
    .map((id) => find(allFolders, { id }))
    .filter(Boolean)
    .map((f) => ({ id: f.id, name: f.name }))
}

function SearchPreviewFolder({
  hit, storeFolder, subfolders, sets, questions, ancestorPath,
}) {
  const folder = storeFolder || hit
  const editedAt = folder && folder.clientModified

  return (
    <div className='searchPreviewPane searchPreviewPane--folder'>
      <div className='searchPreviewPane-header'>
        <div className='searchPreviewPane-header-icon'>
          <Icon name={folder && folder.readOnly ? 'folder-isbe' : 'folder'} />
        </div>
        <div className='searchPreviewPane-header-text'>
          <div className='searchPreviewPane-header-title'>
            {(folder && folder.name) || 'Untitled Folder'}
          </div>
          {ancestorPath.length > 0 && (
            <div className='searchPreviewFolder-breadcrumb'>
              {ancestorPath.map((node, idx) => (
                <React.Fragment key={node.id}>
                  {idx > 0 && <Icon name='chevron-right' />}
                  <span className='searchPreviewFolder-breadcrumb-name'>{node.name}</span>
                </React.Fragment>
              ))}
            </div>
          )}
          {editedAt && (
            <div className='searchPreviewPane-header-subtitle'>
              {'Edited '}
              {formatDate(editedAt)}
            </div>
          )}
        </div>
      </div>
      <div className='searchPreviewPane-body searchPreviewFolder'>
        <SearchPreviewChildList
          folders={subfolders}
          sets={sets}
          questions={questions}
          emptyLabel='Folder has no content'
        />
      </div>
    </div>
  )
}

function mapStateToProps(state, ownProps) {
  const id = ownProps.hit && ownProps.hit.id
  if (!id) {
    return {
      storeFolder: null, subfolders: [], sets: [], questions: [], ancestorPath: [],
    }
  }
  const storeFolder = find(state.folders, { id })
  const { hit } = ownProps
  const ancestorIds = (storeFolder && storeFolder.ancestors) || (hit && hit.ancestors) || []

  const subfolders = sortBy(
    filter(state.folders, (f) => f && f.parent === id && !f.archived),
    'name',
  )
  const sets = sortBy(
    filter(state.sets, (s) => s && s.folder === id && !s.archived),
    'name',
  )
  const questions = sortBy(
    filter(state.questions, (q) => q && q.folder === id && !q.archived),
    (q) => -((q.clientModified && new Date(q.clientModified).getTime()) || 0),
  )
  const ancestorPath = resolveAncestors(ancestorIds, state.folders)
  return {
    storeFolder, subfolders, sets, questions, ancestorPath,
  }
}

export default connect(mapStateToProps)(SearchPreviewFolder)
